import React from 'react'
import { useHistory } from 'react-router-dom'
import { useDeleteRequest } from '../../hooks/request'
import { ANIMAL_DETAIL } from '../../urls'
import { useModal } from '../../hooks/modal'
import Button from '../common/Button'
import AnimalUpdate from './AnimalUpdate'
import { getDate } from '../../utils/date'

export default function AnimalItem({ item, index, onRefresh, animalTypes }) {
    const history = useHistory()
    const animalRemove = useDeleteRequest({ url: ANIMAL_DETAIL.replace('{id}', item.id) })

    const [showEditModal, hideEditModal] = useModal(
        <AnimalUpdate
            item={item}
            onSuccess={() => {
                hideEditModal()
                onRefresh()
            }}
            onCancel={() => hideEditModal()}
            animalTypes={animalTypes || []}
        />,
    )

    async function onDelete() {
        if (global.confirm('Сиз чинакамдан ўчиришни истайсизми?')) {
            const { success } = await animalRemove.request()
            if (success) {
                onRefresh()
            }
        }
    }

    function handleRowClick() {
        history.push(`/animals/${item.id}`)
    }

    return (
        <tr className="is-size-6 pointer" style={{ cursor: 'pointer' }}>
            <td onClick={handleRowClick}>{index + 1}</td>
            <td onClick={handleRowClick}>
                {item.imageUrl ? (
                    <figure className="image is-64x64" style={{ display: 'inline-block', marginRight: '10px' }}>
                        <img
                            width={100}
                            height={100}
                            src={item.imageUrl}
                            alt={item.name}
                            style={{ objectFit: 'cover', borderRadius: '4px' }}
                            onError={(e) => {
                                console.error('Image failed to load:', item.imageUrl)
                                e.target.style.display = 'none'
                            }}
                        />
                    </figure>
                ) : (
                    <span style={{ color: '#999' }}>📷</span>
                )}
            </td>
            <td onClick={handleRowClick}>
                <strong>{item.identificationNumber}</strong>
            </td>
            <td onClick={handleRowClick}>
                <span className={`tag ${item.gender === 'male' ? 'is-info' : 'is-danger'}`}>
                    {item.genderDisplay}
                </span>
            </td>
            <td onClick={handleRowClick}>{item.animalTypeName || '-'}</td>
            <td onClick={handleRowClick}>{item.birthDate ? getDate(item.birthDate) : '-'}</td>
            <td onClick={handleRowClick}>

                <span className={`tag ${
                    // eslint-disable-next-line no-nested-ternary
                    item.status === 'active' ? 'is-success'
                        // eslint-disable-next-line no-nested-ternary
                        : item.status === 'sold' ? 'is-info'
                            // eslint-disable-next-line no-nested-ternary
                            : item.status === 'died' ? 'is-danger'
                                : item.status === 'lost' ? 'is-warning' : 'is-light'
                }`}>
                    {item.statusDisplay || '-'}
                </span>
            </td>
            <td>
                <div style={{ display: 'flex', gap: '5px' }}>
                    <Button
                        onClick={(e) => {
                            e.stopPropagation()
                            history.push(`/animals/${item.id}`)
                        }}
                        className="button is-info is-outlined is-small"
                        icon="eye-outline"
                        text="Кўриш"
                    />
                    <Button
                        onClick={(e) => {
                            e.stopPropagation()
                            showEditModal()
                        }}
                        className="button is-warning is-outlined is-small"
                        icon="create-outline"
                        text="Таҳрирлаш"
                    />
                    <Button
                        onClick={(e) => {
                            e.stopPropagation()
                            onDelete()
                        }}
                        className="button is-danger is-outlined is-small"
                        icon="trash"
                        loading={animalRemove.loading}
                    />
                </div>
            </td>
        </tr>
    )
}
